import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function FAQ() {
  const {
    t,
    tArray
  } = useLanguage();
  const faqs = tArray<{
    q: string;
    a: string;
  }>('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-ivory" id="faq" data-id="element-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-26">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-27">
            {t('faq.title')}
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="border border-gold/20 rounded-sm bg-marble overflow-hidden" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-30">
                <span className="font-heading text-lg text-navy pr-8" data-id="element-31">
                  {faq.q}
                </span>
                <span className={`text-saffron transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`} data-id="element-32">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-33">
                    <path d="M12 5v14M5 12h14" data-id="element-34" />
                  </svg>
                </span>
              </button>

              <AnimatePresence data-id="element-35">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36">
                    <div className="px-6 pb-5 text-navy/70 leading-relaxed border-t border-gold/10 pt-4" data-id="element-37">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}